import React, { useEffect, useState } from 'react'
import ItemImage from '../ItemImage'
import ImageModal from './ImageModal'
import Thumbs from './Thumbs'
import styled from 'styled-components'

const ImgContainer = styled.div`
    height: 250px;
    width: 320px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: ${props => props.hasLink ? 'pointer' : null};
`

const ThumbContainer = styled.div`
    margin-top: 15px;
`

export default function MultiImage(props) {
    const { details, size, textSize, postCart, link } = props
    const { itemMedia } = details

    const [grouped, setGrouped] = useState({})
    const [groupedKey, setGroupedKey] = useState()
    const [modalOpen, setModalOpen] = useState(false)

    useEffect(() => {
        if (itemMedia?.length) {
            const grouped = groupImages(itemMedia)
            const groupedKey = Math.min(...Object.keys(grouped))

            setGrouped(grouped)
            setGroupedKey(`${groupedKey}`)
        }
    }, [itemMedia?.length])

    function groupImages(images) {
        const grouped = {}
        for (const i of images) {
            const key = i.sequence
            if (grouped[key]) {
                grouped[key].push(i)
            } else {
                grouped[key] = [i]
            }
        }
        return grouped
    }

    return (
        <div>
            {Object.keys(grouped).length <= 1 ? (
                <ImgContainer
                    onClick={() => details.itemMedia.length > 0 ? setModalOpen(true) : null}
                    hasLink={details.itemMedia.length > 0}
                >
                    <ItemImage {...{
                        details,
                        size,
                        textSize,
                        postCart,
                        link
                    }} />
                </ImgContainer>
            ) : groupedKey ? (
                <>
                    <ImgContainer onClick={() => setModalOpen(true)}>
                        <ItemImage {...{
                            details: { ...details, itemMedia: grouped[groupedKey] },
                            size,
                            textSize,
                            postCart,
                            link
                        }} />
                    </ImgContainer>
                    <ThumbContainer>
                        <Thumbs {...{ grouped, setGroupedKey, groupedKey }} />
                    </ThumbContainer>
                </>
            ) : null}
            <ImageModal {...{
                open: modalOpen,
                onClose: () => setModalOpen(false),
                grouped,
                groupedKey,
                setGroupedKey
            }} />
        </div>
    )
}